import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { pendingMembershipExportColumns } from '../../config/exportColumns/pendingMembershipExportColumns'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { appPendingMembership } from '../../store/pendingmembers'

function RequstedUser() {
	const dispatch = useDispatch()

	const [exportFilters, setExportFilters] = useState({})

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Membership contribution approval</div>
					<ExportButton
						fetchAction={params =>
							dispatch(
								appPendingMembership({
									...params,
									...exportFilters,
									sanstha: sansthaId || permissionOfSanstha,
									limit: 10000,
									loading: false,
								}),
							)
						}
						columns={pendingMembershipExportColumns}
						fileName="Pending_Memberships"
						sheetName="Pending Memberships"
						buttonText="Export Pending Memberships"
					/>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default RequstedUser
